import { useSimulationStore } from '@/store'
import { useUIStore } from '@/store'

export function useSimulation() {
  const results = useSimulationStore((s) => s.results)
  const isCalculating = useSimulationStore((s) => s.isCalculating)
  const totalMonthlyBudget = useSimulationStore((s) => s.totalMonthlyBudget)
  const selectedStrategy = useUIStore((s) => s.selectedStrategy)
  const setSelectedStrategy = useUIStore((s) => s.setSelectedStrategy)
  const extraMonthlyPayment = useUIStore((s) => s.extraMonthlyPayment)
  const setExtraMonthlyPayment = useUIStore((s) => s.setExtraMonthlyPayment)

  const selectedResult = results[selectedStrategy]
  const minimumResult = results.minimum_only

  const savingsVsMinimum =
    selectedResult && minimumResult && minimumResult.didConverge
      ? minimumResult.totalInterestPaid - selectedResult.totalInterestPaid
      : null

  const monthsSaved =
    selectedResult && minimumResult && minimumResult.didConverge && selectedResult.didConverge
      ? minimumResult.monthsToPayoff - selectedResult.monthsToPayoff
      : null

  return {
    results,
    selectedResult,
    minimumResult,
    isCalculating,
    totalMonthlyBudget,
    selectedStrategy,
    setSelectedStrategy,
    extraMonthlyPayment,
    setExtraMonthlyPayment,
    savingsVsMinimum,
    monthsSaved,
  }
}
